// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.type_enum_08c79ad0 */
var TypeEnum08c79ad0;
(function (TypeEnum08c79ad0) {
    TypeEnum08c79ad0["centrifugation"] = "centrifugation";
    TypeEnum08c79ad0["flocculant addition"] = "flocculant addition";
    TypeEnum08c79ad0["heating"] = "heating";
    TypeEnum08c79ad0["water bathing"] = "water bathing";
    TypeEnum08c79ad0["acidification"] = "acidification";
    TypeEnum08c79ad0["freeze drying"] = "freeze drying";
    TypeEnum08c79ad0["neutralization"] = "neutralization";
})(TypeEnum08c79ad0 || (TypeEnum08c79ad0 = {}));
;
export default TypeEnum08c79ad0;
/** Zod schema for type_enum_08c79ad0 */
export const typeEnum08c79ad0 = z.nativeEnum(TypeEnum08c79ad0);
//# sourceMappingURL=TypeEnum08c79ad0.js.map